import { isOpenQuoteAndOrderCalendarModal } from "@/atoms/is-open-quote-and-order-calendar-modal";
import { quoteAndOrderDurationState } from "@/atoms/quote-and-order-duration-state";
import { ButtonColor } from "@/common/enum/button-color";
import { Button, Modal } from "flowbite-react";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { CustomDatepicker } from "../datepicker/CustomDatepicker";
import { TextInputLabel } from "../label/TextInputLabel";

export const PartnerQuoteCalendarModal = () => {
  const [modal, setModal] = useRecoilState(isOpenQuoteAndOrderCalendarModal);
  const [selectedDuration, setSelectedDuration] = useRecoilState(
    quoteAndOrderDurationState
  );
  const [startDate, setStartDate] = useState<Date | undefined>(modal.startDate);
  const [endDate, setEndDate] = useState<Date | undefined>(modal.endDate);
  const [isExpanded, setIsExpanded] = useState(false);

  const isSubmitDisabled = !(startDate && endDate);

  const closeModal = () => {
    setModal({ open: false, startDate: undefined, endDate: undefined });
    setStartDate(undefined);
    setEndDate(undefined);
  };

  const handleSubmit = async () => {
    setModal({
      open: false,
      startDate,
      endDate,
    });
    setSelectedDuration({ startDate: undefined, endDate: undefined });
  };

  const handleStartDate = (date: Date) => {
    date.setHours(0, 0, 0, 0);
    setStartDate(date);
  };

  const handleEndDate = (date: Date) => {
    date.setHours(23, 59, 59, 999);
    setEndDate(date);
  };

  const handleFocus = () => {
    setIsExpanded(true);
  };

  useEffect(() => {
    setIsExpanded(false);
  }, [startDate, endDate]);

  if (!modal.open) {
    return null;
  }

  return (
    <Modal size="2xl" className="h-full" show={true} onClose={closeModal}>
      <Modal.Header>기간 설정</Modal.Header>
      <Modal.Body className="px-[24px] pt-[24px]">
        <div className="flex gap-[8px] mt-[20px]">
          <div className="flex flex-col w-full" onFocus={handleFocus}>
            <TextInputLabel
              required
              className="mb-[4px] text-semantic-text-heading"
            >
              시작일
            </TextInputLabel>
            <CustomDatepicker
              selectedDate={startDate}
              maxDate={endDate}
              onDateChange={handleStartDate}
            />
          </div>
          <div className="flex flex-col w-full" onFocus={handleFocus}>
            <TextInputLabel
              required
              className="mb-[4px] text-semantic-text-heading"
            >
              종료일
            </TextInputLabel>
            <CustomDatepicker
              selectedDate={endDate}
              minDate={startDate}
              onDateChange={handleEndDate}
            />
          </div>
          {isExpanded && <div className="h-[500px] bg-transparent" />}
        </div>
      </Modal.Body>
      <Modal.Footer className="pt-0 border-none">
        <Button
          size="xl"
          className="w-full"
          color={isSubmitDisabled ? "" : ButtonColor.PRIMARY}
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
        >
          적용하기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
